
export enum PassUsageCalculationMode {
  VoucherValue = 'VoucherValue',
  ZeroPrice = 'ZeroPrice',
  Hidden = 'Hidden',
}
